import React from 'react'
import {ContainerDimensionsContextProvider, Modal} from '@therms/atalaya'
import {ViewRecord} from './ViewRecord'

interface ViewRecordModalProps {
  closeHandler: () => void
  recordId: string
}

function RecordModal({closeHandler, recordId}: ViewRecordModalProps) {
  return (
    <Modal
      closeHandler={closeHandler}
      outsideClickClose
      showClose={false}
      width="xl"
    >
      <ContainerDimensionsContextProvider asViewport>
        <div className="min-h-48">
          <ViewRecord recordId={recordId} closeHandler={closeHandler} />
        </div>
      </ContainerDimensionsContextProvider>
    </Modal>
  )
}

export {RecordModal}
